import styled from "@emotion/styled";

export const AutofillPopup = styled.div`
  position: absolute;
  z-index: 20;
  padding: 10px;
  border-radius: 15px;
  height: 100px;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  gap: 5px;
  background-color: ${({ theme }) => theme.colors.inputBg[0]};
`;
